// safe-react-wrapper.tsx
import React, { memo } from 'react'

export interface SafeReactWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Custom styles for the wrapper
   * @deprecated Use className or the style prop directly instead
   */
  gameplayStyle?: React.CSSProperties
  /**
   * If true, will warn about usage of gameplayStyle prop
   * @default true
   */
  warnAboutLegacyProps?: boolean
}

export const SafeReactWrapper: React.FC<SafeReactWrapperProps> = memo((props) => {
  const {
    gameplayStyle,
    style,
    warnAboutLegacyProps = true,
    children,
    ...validProps
  } = props

  // Combine all style sources
  const combinedStyle: React.CSSProperties = {
    all: 'initial', // Reset all CSS properties
    contain: 'content', // Contain the scope of styles
    display: 'block',
    isolation: 'isolate', // Prevent style leakage
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    ...style,
    ...gameplayStyle, // gameplayStyle overrides style if conflicts exist
  }

  // Warn about deprecated props
  if (warnAboutLegacyProps && gameplayStyle) {
    console.warn(
      'The gameplayStyle prop is deprecated. Please use the standard style prop instead.',
      {
        gameplayStyle,
        component: 'SafeReactWrapper',
      }
    )
  }

  return (
    <div
      {...validProps}
      style={combinedStyle}
      className="react-isolated-container"
    >
      {children}
    </div>
  )
})

SafeReactWrapper.displayName = 'SafeReactWrapper'

export default SafeReactWrapper
